import * as constants from 'vd-constants';

// IMPORTANT: Intercom has a maximum event count of 120
// Please ensure that the event being enabled for tracking in Intercom is needed for customer support

// See also coreAnalyticsEvents.
export const TRACKING_EVENTS = {
  // MISC
  SHOW_KEYBOARD_SHORTCUTS: {
    name: 'show-keyboard-shortcuts',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Date Picker
   */
  DATE_PICKER_INCREMENT: {
    // RENAMED FROM: incremented-date
    name: 'increment-date',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DATE_PICKER_DECREMENT: {
    // RENAMED FROM: decremented-date
    name: 'decrement-date',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DATE_PICKER_SELECT: {
    name: 'select-date',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DATE_PICKER_OPEN: {
    // RENAMED FROM: open-calendar
    name: 'open-date-picker',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Dashboard Page
   */
  DASHBOARD_WIDGET_COUNT_BY_PAGE: {
    name: 'dashboard-widget-count-by-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_CREATE_WIDGET_START: {
    name: 'dashboard-create-widget-start',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_CREATE_WIDGET: {
    name: 'dashboard-create-widget',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_DELETE_WIDGET: {
    name: 'dashboard-delete-widget',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_HIDE_WIDGET: {
    name: 'dashboard-hide-widget',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_SHOW_WIDGET: {
    name: 'dashboard-show-widget',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_RESET_WIDGET: {
    name: 'dashboard-reset-widget',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_SET_FILTERS: {
    name: 'dashboard-set-filters',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_PAGE_LOAD_TIME: {
    name: 'dashboard-page-load-time',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_LOAD_TIME: {
    name: 'dashboard-widget-load-time',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_DRILLDOWN: {
    name: 'dashboard-widget-drilldown',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_FAILED_TO_LOAD: {
    name: 'dashboard-widget-failed-to-load',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_INVALID_LOCATION_IGNORED: {
    name: 'dashboard-widget-invalid-location-ignored',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_CHART_TOGGLE: {
    name: 'dashboard-widget-chart-toggle',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DASHBOARD_WIDGET_REORDER: {
    name: 'dashboard-widget-reorder',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Discover
   */
  DISCOVER_CHART_CREATE: {
    // PROPOSED RENAME: create-discover-chart
    name: 'create-dashboard',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_CHART_HIDE: {
    // PROPOSED RENAME: hide-discover-chart
    name: 'delete-dashboard',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_CHART_INVESTIGATE: {
    // PROPOSED RENAME: investigate-discover-chart
    name: 'dashboard-view-events',
    trackIntercom: true,
    trackMixpanel: true,
  },
  DISCOVER_VIEW_SWITCH: {
    name: 'switch-discover-events-view',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_VIEW_CLOSE: {
    name: 'close-discover-events-view',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_TABLE_VIEW_COLUMNS_CHANGE: {
    name: 'change-table-view-columns',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_TABLE_VIEW_SORT_CHANGE: {
    name: 'change-table-view-sort',
    trackIntercom: false,
    trackMixpanel: true,
  },
  DISCOVER_EVENT_CLICK: {
    // PROPOSED RENAME: click-discover-event
    name: 'dashboard-click-event',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Events
   */
  EVENT_MENU_SHARE: {
    name: 'click-event-menu-share',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_MENU_VIEW_SHARE: {
    // TODO: will be logged on title click too
    // PROPOSED RENAME: click-event-menu-view-share
    name: 'view-share',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_MENU_NOTES_CHANGE: {
    name: 'click-event-menu-notes',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_MENU_COPY: {
    name: 'click-event-menu-copy',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_MENU_FAVOURITE: {
    name: 'click-event-menu-favourite',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_MENU_DELETE: {
    name: 'click-event-menu-delete',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_REPORT_SELECT: {
    name: 'select-report',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_SEARCH_ADD: {
    name: 'add-event-filter',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_SEARCH_REMOVE: {
    name: 'remove-event-filter',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_PARAMETERIZED_SEARCH_ADD: {
    name: 'add-event-parameter',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_PARAMETERIZED_SEARCH_REMOVE: {
    name: 'remove-event-parameter',
    trackIntercom: false,
    trackMixpanel: true,
  },
  FILTER_REPORT_CREATE: {
    name: 'create-report',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_VIEW: {
    name: 'view-event',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_ADD_NOTES: {
    name: 'add-notes',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_NOTES_EDIT: {
    name: 'edit-notes',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_SHARE_TOGGLE: {
    name: 'event-share-toggle',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_SHARE_COPY: {
    // PROPOSED RENAME: share-event-copy-link
    name: 'get-share-link',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_SHARE_EMAIL: {
    // PROPOSED RENAME: share-event-email-link
    name: 'email-share-link',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_SHARE_CSV_EXPORT: {
    // PROPOSED RENAME: share-event-csv-export
    name: 'export-to-csv',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_FAVOURITE_TOGGLE: {
    // PROPOSED RENAME: toggle-event-favourite
    name: 'star-event',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_DATE_PERIOD: {
    name: 'select-time-period',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_LOCATION_SELECT: {
    name: 'select-location',
    trackIntercom: true,
    trackMixpanel: true,
  },
  SELECT_LOCATIONS: {
    name: 'select-locations',
    trackIntercom: true,
    trackMixpanel: true,
  },
  TOGGLED_EVENT_TYPE_FILTER: {
    name: 'toggled-event-type-filter',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_HISTOGRAM_TIME_SELECT: {
    name: 'click-histogram-time',
    trackIntercom: false,
    trackMixpanel: true,
  },
  EVENT_CLICK: {
    name: 'event-clicked',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EVENT_FEATURE: {
    name: 'event-feature',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Navigation
   */
  NAVIGATION_TAB_SELECT: {
    name: 'tab-selected', // TODO see https://solink.atlassian.net/browse/SOL-2786
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Page Load
   */
  PAGE_LOAD_DASHBOARD: {
    name: 'load-dashboard-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_EVENT: {
    name: 'load-event-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_DISCOVER: {
    name: 'load-discover-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_VIDEO: {
    name: 'load-video-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_ACCOUNT: {
    name: 'load-account-page',
    trackIntercom: false,
    trackMixpanel: false,
  },
  PAGE_LOAD_PREFERENCES: {
    name: 'load-preferences-page',
    trackIntercom: false,
    trackMixpanel: false,
  },
  PAGE_LOAD_NOTIFICATIONS: {
    // TODO This is now the report settings page
    name: 'load-notifications-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_SETTINGS: {
    name: 'load-settings-page',
    trackIntercom: false,
    trackMixpanel: false,
  },
  PAGE_LOAD_APPS: {
    name: 'load-apps-page',
    trackIntercom: false,
    trackMixpanel: false,
  },
  PAGE_LOAD_USERS: {
    name: 'load-users-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_EDIT_USER: {
    name: 'load-edit-user-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  // startCase → "Load Investigations Page" (same Mixpanel name as mobile).
  PAGE_LOAD_INVESTIGATIONS: {
    name: 'load-investigations-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PAGE_LOAD_INVESTIGATION_DETAIL: {
    name: 'load-investigation-detail-page',
    trackIntercom: false,
    trackMixpanel: true,
  },
  INVESTIGATION_CREATED: {
    name: 'investigation-created',
    trackIntercom: false,
    trackMixpanel: true,
  },
  INVESTIGATION_UPDATED: {
    name: 'investigation-updated',
    trackIntercom: false,
    trackMixpanel: true,
  },
  INVESTIGATION_STATUS_CHANGED: {
    name: 'investigation-status-changed',
    trackIntercom: false,
    trackMixpanel: true,
  },
  INVESTIGATION_EVIDENCE_UPDATED: {
    name: 'investigation-evidence-updated',
    trackIntercom: false,
    trackMixpanel: true,
  },
  // Literal name. Matches mobile CLIP_INVESTIGATION_LINKED. startCase would drop the hyphen.
  CLIP_INVESTIGATION_LINKED: {
    name: 'Clip - Investigation Linked',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Referral
   */
  REFERRAL_CLICK: {
    // PROPOSED RENAME: click-referral
    name: 'clicked-referral-program',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Help Center
   */
  HELPCENTER_CLICK: {
    // PROPOSED RENAME: click-referral
    name: 'help-center',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Save and Share
   */
  SAVE_AND_SHARE_CLICK: {
    name: 'click-save-and-share',
    trackIntercom: false,
    trackMixpanel: true,
  },
  SAVE_AND_SHARE_CREATE: {
    // PROPOSED RENAME: create-save-and-share
    name: 'create-share',
    trackIntercom: true,
    trackMixpanel: true,
  },
  UPLOAD_CLIP_VIDEO: {
    name: 'upload-clip-video',
    trackIntercom: false,
    trackMixpanel: true,
  },
  // click retry button to upload clip video for one camera
  RETRY_CLIP_VIDEO_CLICK: {
    name: 'retry-clip-video-click',
    trackIntercom: false,
    trackMixpanel: true,
  },
  SAVE_AND_SHARE_VIEW_SHARE: {
    name: 'click-shared-link',
    trackIntercom: true,
    trackMixpanel: true,
  },
  LOCAL_DOWNLOAD_CREATE: {
    // PROPOSED RENAME: create-local-download
    name: 'create-download',
    trackIntercom: true,
    trackMixpanel: true,
  },
  LOCAL_DOWNLOAD_CLIP_CLICK: {
    name: 'download-shared-clip',
    trackIntercom: true,
    trackMixpanel: true,
  },
  LOCAL_DOWNLOAD_VIEW: {
    name: 'view-download',
    trackIntercom: true,
    trackMixpanel: true,
  },
  LOCAL_DOWNLOAD_FILE_DOWNLOAD: {
    name: 'download-video',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Users
   */
  USER_ADD: {
    // PROPOSED RENAME: add-user or create-user
    name: 'user-created',
    trackIntercom: true,
    trackMixpanel: true,
  },
  USER_DELETE: {
    // PROPOSED RENAME: delete-user
    name: 'user-deleted',
    trackIntercom: true,
    trackMixpanel: true,
  },
  USER_PASSWORD_CHANGE: {
    name: 'change-password',
    trackIntercom: false,
    trackMixpanel: true,
  },
  USER_SUPPORT_ACCESS_CHANGE: {
    // RENAMED FROM: changed-allow-support-access
    name: 'change-support-access',
    trackIntercom: false,
    trackMixpanel: false,
  },
  REPORT_DIGEST_NOTIFICATION_TOGGLE: {
    name: 'digest-notification-toggle',
    trackIntercom: false,
    trackMixpanel: false,
  },

  /**
   * Video
   */
  FAVOURITE_CAMERA_ADD: {
    // PROPOSED RENAME: add-favorite-camera
    name: 'save-favourite-cams',
    trackIntercom: false,
    trackMixpanel: true,
  },
  FAVOURITE_CAMERA_REMOVE: {
    // PROPOSED RENAME: remove-favorite-camera
    name: 'remove-favourite-cams',
    trackIntercom: false,
    trackMixpanel: true,
  },
  LOCATION_SELECT_VIDEO: {
    name: 'location-select-video',
    trackIntercom: true,
    trackMixpanel: true,
  },
  SELECT_CAMERA_GROUP: {
    name: 'select-camera-group',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_PLAY_PAUSE: {
    name: 'pause-play',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_EXPAND_COLLAPSE: {
    name: 'expand-collapse',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_ZOOM: {
    // RENAMED FROM: toggle-zoom
    name: 'zoom-video',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_LIVE_WATCH: {
    name: 'watch-live-video',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_GO_LIVE: {
    name: 'play-live',
    trackIntercom: false,
    trackMixpanel: true,
  },
  QUICK_PLAY_LOAD_TIME_MEASURE: {
    name: 'measured-quick-video-load-time',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CANERA_LINK_TOGGLE: {
    name: 'camera-link-toggle',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CAMERA_LINK_CLICK: {
    name: 'camera-link-click',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CANERA_LINK_UPDATE: {
    name: 'camera-link-update',
    trackIntercom: true,
    trackMixpanel: true,
  },
  CAMERA_LINK_CREATE: {
    name: 'camera-link-create',
    trackIntercom: true,
    trackMixpanel: true,
  },
  CAMERA_LINK_DELETE: {
    name: 'camera-link-delete',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_HEATMAP: {
    name: 'toggle-heatmap',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_MOTION_SEARCH: {
    name: 'toggle-motion-search',
    trackIntercom: true,
    trackMixpanel: true,
  },
  EDIT_MOTION_ZONE: {
    name: 'edit-motion-zone',
    trackIntercom: true,
    trackMixpanel: true,
  },
  USE_MOTION_SEARCH_DURATION_THRESHOLD: {
    name: 'use-motion-search-duration-threshold',
    trackIntercom: true,
    trackMixpanel: true,
  },
  USE_MOTION_SEARCH_INTENSITY_THRESHOLD: {
    name: 'use-motion-search-intensity-threshold',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_RECEIPT_TOGGLE: {
    // RENAMED FROM: toggle-show-receipt
    name: 'toggle-video-receipt',
    trackIntercom: false,
    trackMixpanel: false,
  },
  VIDEO_SEARCH_TERM: {
    name: 'search-video',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MOTION_ALERTS_SELECTED: {
    name: 'motion-alerts-selected',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MOTION_ALERT_GRID_RESET: {
    name: 'motion-alert-grid-reset',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MOTION_ALERT_GRID_ERASE: {
    name: 'motion-alert-grid-erase',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MOTION_ALERT_GRID_HIGHLIGHT: {
    name: 'motion-alert-grid-highlight',
    trackIntercom: false,
    trackMixpanel: true,
  },
  SET_MOTION_ROI: {
    name: 'set-motion-roi', // TODO see https://solink.atlassian.net/browse/SOL-2786 and https://solink.atlassian.net/browse/SOL-2789
    trackIntercom: true,
    trackMixpanel: true,
  },
  MOTION_ALERT_AI_DETECTION_TYPE_SAVED: {
    name: 'motion-alert-ai-detection-type-saved',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_TIMELINE_DRAG: {
    // PROPOSED RENAME: drag-video-timeline
    name: 'drag-timeline',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_VIEWPORT_DRAG: {
    name: 'drag-viewport',
    trackIntercom: false,
    trackMixpanel: false,
  },
  VIDEO_NEXT_EVENT_JUMP: {
    name: 'go-to-next-event',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_PREVIOUS_EVENT_JUMP: {
    name: 'go-to-previous-event',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_GO_BACK_ONE_FRAME: {
    name: 'go-back-one-frame',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_GO_FORWARD_ONE_FRAME: {
    name: 'go-forward-one-frame',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_GO_BACK_10_SECONDS: {
    name: 'go-back-10-seconds',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_GO_FORWARD_10_SECONDS: {
    name: 'go-forward-10-seconds',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_REWIND: {
    name: 'rewind',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_FAST_FORWARD: {
    name: 'fast-forward',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_HD_TOGGLE: {
    name: 'toggle-hd',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_HD_PLAY: {
    name: 'play-hd',
    trackIntercom: true,
    trackMixpanel: true,
  },
  VIDEO_SD_PLAY: {
    name: 'play-sd',
    trackIntercom: true,
    trackMixpanel: true,
  },
  SNAPSHOT_DOWNLOAD: {
    name: 'download-snapshot',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MULTIVIEW_VIDEO_CAMERA_ADD: {
    // RENAMED FROM: add-to-playlist
    name: 'add-camera',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MULTIVIEW_VIDEO_CAMERA_REMOVE: {
    // RENAMED FROM: remove-from-playlist
    name: 'remove-camera',
    trackIntercom: false,
    trackMixpanel: true,
  },
  MULTIVIEW_PLAY: {
    name: 'play-multiview',
    trackIntercom: false,
    trackMixpanel: true,
  },
  PIN_EVENT: {
    name: 'pin-event',
    trackIntercom: false,
    trackMixpanel: true,
  },
  UNPIN_EVENT: {
    name: 'unpin-event',
    trackIntercom: false,
    trackMixpanel: true,
  },
  NAVIGATE_24HR_TIMELINE: {
    name: 'navigate_24hr_timeline',
    trackIntercom: false,
    trackMixpanel: true,
  },
  NAVIGATE_MAIN_TIMELINE: {
    name: 'navigate_main_timeline',
    trackIntercom: false,
    trackMixpanel: true,
  },
  TEN_MINUTES_OF_VIDEO_CONTINUOUSLY_PLAYING: {
    name: 'ten_minutes_of_video_continuously_playing',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CONTINUE_WATCHING_VIDEO: {
    name: 'continue_watching_video',
    trackIntercom: false,
    trackMixpanel: true,
  },
  /**
   * Camera Groups
   */
  CAMERA_GROUP_CREATED: {
    name: 'camera-group-created',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CAMERA_GROUP_DELETED: {
    name: 'camera-group-deleted',
    trackIntercom: false,
    trackMixpanel: true,
  },
  CAMERA_GROUP_UPDATED: {
    name: 'camera-group-updated',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Video Wall Layout
   */
  LAUNCHED_VIDEO_WALL: {
    name: 'launched-layout-view',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Video Alarms
   */
  ALARM_ARM: {
    name: 'alarm-arm',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_DISARM: {
    name: 'alarm-disarm',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_SCHEDULE: {
    name: 'alarm-schedule',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_ARM_UNTIL: {
    name: 'alarm-arm-until',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_DISARM_UNTIL: {
    name: 'alarm-disarm-until',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_MONITORING_MODE: {
    name: 'alarm-monitoring-mode',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_CAMERA_ENABLE: {
    name: 'alarm-camera-enable',
    trackIntercom: true,
    trackMixpanel: true,
  },

  ALARM_CAMERA_DISABLE: {
    name: 'alarm-camera-disable',
    trackIntercom: true,
    trackMixpanel: true,
  },

  ALARM_CAMERAS_FILTER: {
    name: 'alarm-cameras-filter',
    trackIntercom: false,
    trackMixpanel: true,
  },

  SELECT_ALARM_CAMERA_TAG: {
    name: 'select-alarm-camera-tag',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_CONTACT_ADD: {
    name: 'alarm-contact-add',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_CONTACT_REMOVE: {
    name: 'alarm-contact-remove',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_CONTACT_UPDATE: {
    name: 'alarm-contact-update',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_PIN_ADD: {
    name: 'alarm-pin-add',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_PIN_REMOVE: {
    name: 'alarm-pin-remove',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_PIN_UPDATE: {
    name: 'alarm-pin-update',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_PIN_VIEW: {
    name: 'alarm-pin-view',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_SCHEDULED_EXCEPTION_ADD: {
    name: 'alarm-scheduled-exception-add',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_SCHEDULED_EXCEPTION_UPDATE: {
    name: 'alarm-scheduled-exception-update',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_SCHEDULED_EXCEPTION_DELETE: {
    name: 'alarm-scheduled-exception-delete',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  SCHEDULED_SPOT_CHECK_CREATED: {
    name: 'scheduled-spot-check-created',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.SCHEDULED_AI_CHAT_REASON,
  },

  SCHEDULED_SPOT_CHECK_UPDATED: {
    name: 'scheduled-spot-check-updated',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.SCHEDULED_AI_CHAT_REASON,
  },
  // TODO: track SCHEDULED_AI_PREVIEW_DELETED when design is ready

  SCHEDULED_SPOT_CHECK_PREVIEW_CREATED: {
    name: 'scheduled-spot-check-preview-created',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.SCHEDULED_AI_CHAT_REASON,
  },

  ALARM_GUEST_ACCESS_ADD: {
    name: 'alarm-guest-access-add',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_GUEST_ACCESS_RESEND: {
    name: 'alarm-guest-access-resend',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_GUEST_ACCESS_REVOKE: {
    name: 'alarm-guest-access-revoke',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_GUEST_ACCESS_REMOVE: {
    name: 'alarm-guest-access-remove',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_SCHEDULE_UPDATE: {
    name: 'alarm-schedule-update',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  ALARM_MODE_UPDATE: {
    name: 'alarm-mode-update',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_NOTE_UPDATE: {
    name: 'alarm-note-update',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_KEY_VALUE_UPDATE: {
    name: 'alarm-key-value-update',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_CLOSE: {
    name: 'alarm-close',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ALARM_MOTION_ZONE_UPDATE: {
    name: 'alarm-motion-zone-update',
    trackIntercom: false,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_ALARMS_SUBTYPE,
  },

  /**
   * Thresholds
   */
  THRESHOLD_CREATE: {
    name: 'threshold-create',
    trackIntercom: true,
    trackMixpanel: true,
  },

  THRESHOLD_UPDATE: {
    name: 'threshold-update',
    trackIntercom: true,
    trackMixpanel: true,
  },

  THRESHOLD_DELETE: {
    name: 'threshold-delete',
    trackIntercom: true,
    trackMixpanel: true,
  },

  /**
   * Notifications
   */
  NOTIFICATION_DRAWER_OPENED: {
    name: 'notification-drawer-opened',
    trackIntercom: false,
    trackMixpanel: true,
  },

  NOTIFICATION_FILTER_VIEW: {
    name: 'notification-filter-view',
    trackIntercom: false,
    trackMixpanel: true,
  },

  NOTIFICATION_VIEW: {
    name: 'notification-view',
    trackIntercom: true,
    trackMixpanel: true,
  },

  NOTIFICATION_MARKED_READ: {
    name: 'notification-marked-read',
    trackIntercom: false,
    trackMixpanel: true,
  },

  NOTIFICATION_MARKED_ERROR: {
    name: 'notification-marked-error',
    trackIntercom: false,
    trackMixpanel: true,
  },

  NOTIFICATION_ARCHIVED: {
    name: 'notification-archived',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * Temporary Access
   */
  TEMP_ACCESS_OPENED: {
    name: 'temp-access-opened',
    trackIntercom: true,
    trackMixpanel: true,
  },

  TEMP_ACCESS_GRANTED: {
    name: 'temp-access-granted',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TEMP_ACCESS_FAILED: {
    name: 'temp-access-failed',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /**
   * KIOSK
   */
  SELECTED_LOCATION_ID_NOT_AVAILABLE: {
    name: 'selected-location-id-not-available',
    trackIntercom: false,
    trackMixpanel: true,
  },

  LOCATIONS_API: {
    name: 'locations-api',
    trackIntercom: true,
    trackMixpanel: true,
  },

  CREATE_TEST_ALARM: {
    name: 'create-test-alarm',
    trackIntercom: false,
    trackMixpanel: true,
  },

  SEND_API_REQUEST: {
    name: 'API-request',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ASSIGN_LOCATION_TAGS_TO_LOCATION: {
    name: 'assign-location-tags-to-location',
    trackIntercom: false,
    trackMixpanel: true,
  },

  UPDATE_LOCATION_TAG_CATEGORIES: {
    name: 'update-location-tag-categories',
    trackIntercom: false,
    trackMixpanel: true,
  },

  BULK_ASSIGN_LOCATION_TAGS: {
    name: 'bulk-assign-location-tags',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TOGGLED_PINHOLE_VIEW: {
    name: 'toggled-pinhole-view',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TOGGLED_LIMIT_EVENT_DURATION: {
    name: 'toggled-event-duration',
    trackIntercom: false,
    trackMixpanel: true,
  },

  FETCHING_24_HOUR_ALARM_STATS_ERROR: {
    name: 'fetching-24-hour-alarm-stats-error',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /** Log when VD render string or number type of event data as date time
   *  so that we can add formatter for these fields in event-standard
   */
  RENDER_EVENT_DATA_AS_DATE_TIME: {
    name: 'render-event-data-as-date-time',
    trackIntercom: false,
    trackMixpanel: true,
  },

  CREATE_RISK_FLAG: {
    name: 'creat-risk-flag',
    trackIntercom: false,
    trackMixpanel: true,
  },

  UPDATE_RISK_FLAG: {
    name: 'update-risk-flag',
    trackIntercom: false,
    trackMixpanel: true,
  },

  DELETE_RISK_FLAG: {
    name: 'delete-risk-flag',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EVENT_VERIFY: {
    name: 'event-verify',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EVENT_FLOW_CREATED: {
    name: 'event-flow-created',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EVENT_FLOW_UPDATED: {
    name: 'event-flow-updated',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EVENT_FLOW_DELETED: {
    name: 'event-flow-deleted',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EVENT_FLOW_TAG_REMOVED: {
    name: 'event-flow-tag-removed',
    trackIntercom: false,
    trackMixpanel: true,
  },

  AI_VIDEO_TOOL_CLICK: {
    name: 'ai-video-tool-click',
    trackIntercom: false,
    trackMixpanel: true,
  },

  CREATE_LINE_CROSS_EVENT_LINES: {
    name: 'create-line-cross-event-lines',
    trackIntercom: false,
    trackMixpanel: true,
  },

  EDIT_LINE_CROSS_EVENT_LINES: {
    name: 'edit-line-cross-event-lines',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ACCESS_LINE_CROSS_EVENT_TAB: {
    name: 'access-line-cross-event-tab',
    trackIntercom: false,
    trackMixpanel: true,
  },

  SET_CLOUD_STORAGE_CAMERA_RETENTION_PACKAGE: {
    name: 'set-camera-retention-package',
    trackIntercom: false,
    trackMixpanel: true,
  },

  CLOUD_STORAGE_UPGRADE_REQUESTED: {
    name: 'cloud-storage-upgrade-requested',
    trackIntercom: false,
    trackMixpanel: true,
  },

  SET_SUPPORT_ACCESS: {
    name: 'set-support-access',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TOGGLED_SHOW_ZONE_TRACKING_ZONE: {
    name: 'toggled-show-zone-tracking-zone',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TOGGLED_HIGHLIGHT_OBJECTS: {
    name: 'toggled-highlight-objects',
    trackIntercom: false,
    trackMixpanel: true,
  },

  TOGGLED_HIGHLIGHT_OBJECTS_EXTENDED_INFO: {
    name: 'toggled-highlight-objects-extended-info',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ZONE_TRACKING_CONFIG_SAVED: {
    name: 'zone-tracking-config-saved',
    trackIntercom: false,
    trackMixpanel: true,
  },

  ZONE_MAX_OCCUPANCY_CHANGED: {
    name: 'zone-max-occupancy-changed',
    trackIntercom: false,
    trackMixpanel: true,
  },

  FIELD_STATS_LOAD_TIME: {
    name: 'field-stats-load-time',
    trackIntercom: false,
    trackMixpanel: true,
  },
  /**Video Search  */
  VIDEO_SEARCH_FEEDBACK: {
    name: 'video-search-feedback',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_SEARCH_QUERY: {
    name: 'video-search-query',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_SEARCH_SAVED_CLIP: {
    name: 'video-search-saved-clip',
    trackIntercom: false,
    trackMixpanel: true,
  },
  VIDEO_SEARCH_UPLOAD: {
    name: 'video-search-upload',
    trackIntercom: false,
    trackMixpanel: true,
  },

  /** Service Display Monitoring */
  SDM_EVENT: {
    name: 'service-display-monitoring-event',
    trackIntercom: false,
    trackMixpanel: true,
  },

  PTZ_ENABLE: {
    name: 'ptz-enable',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_VIDEO_SUBTYPE,
  },

  PTZ_DISABLE: {
    name: 'ptz-disable',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_VIDEO_SUBTYPE,
  },

  PTZ_MOVE: {
    name: 'ptz-move',
    trackIntercom: true,
    trackMixpanel: true,
    auditEventSubtype: constants.AUDIT_EVENT_VIDEO_SUBTYPE,
  },
};

export const TAB_NAME = {
  [constants.DASHBOARD_PAGE]: 'Dashboard',
  [constants.EVENTS_PAGE]: 'Events',
  [constants.VIDEO_PAGE]: 'Video',
  [constants.CLIPS_PAGE]: 'Clips',
  [constants.DISCOVER_PAGE]: 'Discover',
  [constants.SETTINGS_PAGE]: 'Settings',
  [constants.ALARMS_PAGE]: 'Alarms',
};

export const VIDEO_LIVE = 'Live';
export const VIDEO_ARCHIVE = 'Archived';

export const TEN_MINUTES_CONTINUOUS_VIDEO = 1000 * 10 * 60;

export const CREATE_TEST_ALARM_STATUS = {
  SUCCEEDED: 'SUCCEEDED',
  FAILED: 'FAILED',
};

export const VIDEO_SEARCH_MEDIA_TYPE = {
  TEXT: 'text',
  IMAGE: 'image',
};

export const VIDEO_SEARCH_MEDIA_METHOD = {
  TEXT: 'text',
  UPLOAD: 'upload',
  VIDEO_PLAYER_CROP: 'video player crop',
};

export const AUDIT_EVENT_CITY = 'city';
export const AUDIT_EVENT_COUNTRY = 'country';
export const AUDIT_EVENT_OS = 'os';
export const AUDIT_EVENT_BROWSER = 'browser';

export const SELECT_LOCATIONS_CONTEXT = {
  GLOBAL_SELECTOR: 'global-selector',
  WIDGET: 'widget',
};
